import { DeviceInterface } from 'features/eai/eaiTypes';
import {
  DailyDiagramInterface,
  DataPointInterface,
  GetDeviceProductionPlanDetailResponse,
  MarketPeriodInterface,
  MonitoredResourceType,
  MonitoredResourceTypeLabel,
  ProductionPlanRevisionInterface,
  TimeIntervalInterface
} from 'features/dispatcher/dispatcherTypes';
import { Theme } from '@mui/material/styles';
import { MarketPeriodsType, MetricValueType } from 'utils/constants';
import { UnitType } from 'utils/characteristic';
import React from 'react';
import { Columns, Datas } from 'react-csv-downloader/dist/cjs/lib/csv';

// ==============================|| PRODUCTION PLAN TYPES ||============================== //

export enum ActivityLogEventCode {
  OPERATION_EVENT_CANCELED = 'OPERATION_EVENT_CANCELED',
  OPERATION_EVENT_DELETED = 'OPERATION_EVENT_DELETED',
  CONTRACT_FULFILLMENT_OPERATION_EVENT_SCHEDULED = 'CONTRACT_FULFILLMENT_OPERATION_EVENT_SCHEDULED',
  PRODUCTION_AVAILABILITY_OPERATION_EVENT_SCHEDULED = 'PRODUCTION_AVAILABILITY_OPERATION_EVENT_SCHEDULED',
  PRODUCTION_UNAVAILABLE_OPERATION_EVENT_SCHEDULED = 'PRODUCTION_UNAVAILABLE_OPERATION_EVENT_SCHEDULED',
  CONTRACT_FULFILLMENT_OPERATION_EVENT_EDITED = 'CONTRACT_FULFILLMENT_OPERATION_EVENT_EDITED',
  PRODUCTION_AVAILABILITY_OPERATION_EVENT_EDITED = 'PRODUCTION_AVAILABILITY_OPERATION_EVENT_EDITED',
  PRODUCTION_UNAVAILABLE_OPERATION_EVENT_EDITED = 'PRODUCTION_UNAVAILABLE_OPERATION_EVENT_EDITED',
  PRODUCTION_PLAN_REVISION_CREATED = 'PRODUCTION_PLAN_REVISION_CREATED',
  PRODUCTION_PLAN_REVISION_UPDATED = 'PRODUCTION_PLAN_REVISION_UPDATED',
  PRODUCTION_PLAN_REVISION_CONFIRMED = 'PRODUCTION_PLAN_REVISION_CONFIRMED',
  PRODUCTION_PLAN_REVISION_PROPAGATED = 'PRODUCTION_PLAN_REVISION_PROPAGATED',
  PRODUCTION_PLAN_REVISION_PLANNED = 'PRODUCTION_PLAN_REVISION_PLANNED',
  PRODUCTION_PLAN_REVISION_REJECTED = 'PRODUCTION_PLAN_REVISION_REJECTED',
  DAILY_DIAGRAM_REVISION_CREATED = 'DAILY_DIAGRAM_REVISION_CREATED',
  DAILY_DIAGRAM_REVISION_UPDATED = 'DAILY_DIAGRAM_REVISION_UPDATED',
  DAILY_DIAGRAM_REVISION_SENT = 'DAILY_DIAGRAM_REVISION_SENT',
  DAILY_DIAGRAM_REVISION_PROPAGATION_FAILED = 'DAILY_DIAGRAM_REVISION_PROPAGATION_FAILED',
  DAILY_DIAGRAM_REVISION_ACCEPTED = 'DAILY_DIAGRAM_REVISION_ACCEPTED',
  DAILY_DIAGRAM_REVISION_RETURNED = 'DAILY_DIAGRAM_REVISION_RETURNED',
  DAY_AHEAD_SYSTEM_IMBALANCE_PREDICTION_GENERATED_SUCCESS = 'DAY_AHEAD_SYSTEM_IMBALANCE_PREDICTION_GENERATED_SUCCESS',
  DAY_AHEAD_SYSTEM_IMBALANCE_PREDICTION_GENERATED_WARNING = 'DAY_AHEAD_SYSTEM_IMBALANCE_PREDICTION_GENERATED_WARNING',
  DAY_AHEAD_SYSTEM_IMBALANCE_PREDICTION_GENERATED_ERROR = 'DAY_AHEAD_SYSTEM_IMBALANCE_PREDICTION_GENERATED_ERROR',
  INTRA_DAY_SYSTEM_IMBALANCE_PREDICTION_UPDATED_SUCCESS = 'INTRA_DAY_SYSTEM_IMBALANCE_PREDICTION_UPDATED_SUCCESS',
  INTRA_DAY_SYSTEM_IMBALANCE_PREDICTION_UPDATED_WARNING = 'INTRA_DAY_SYSTEM_IMBALANCE_PREDICTION_UPDATED_WARNING',
  INTRA_DAY_SYSTEM_IMBALANCE_PREDICTION_UPDATED_ERROR = 'INTRA_DAY_SYSTEM_IMBALANCE_PREDICTION_UPDATED_ERROR',
  DAY_AHEAD_DAM_PRICE_PREDICTION_GENERATED_SUCCESS = 'DAY_AHEAD_DAM_PRICE_PREDICTION_GENERATED_SUCCESS',
  DAY_AHEAD_DAM_PRICE_PREDICTION_GENERATED_WARNING = 'DAY_AHEAD_DAM_PRICE_PREDICTION_GENERATED_WARNING',
  DAY_AHEAD_DAM_PRICE_PREDICTION_GENERATED_ERROR = 'DAY_AHEAD_DAM_PRICE_PREDICTION_GENERATED_ERROR',
  DAY_AHEAD_IDM_PRICE_15M_PREDICTION_GENERATED_SUCCESS = 'DAY_AHEAD_IDM_PRICE_15M_PREDICTION_GENERATED_SUCCESS',
  DAY_AHEAD_IDM_PRICE_15M_PREDICTION_GENERATED_WARNING = 'DAY_AHEAD_IDM_PRICE_15M_PREDICTION_GENERATED_WARNING',
  DAY_AHEAD_IDM_PRICE_15M_PREDICTION_GENERATED_ERROR = 'DAY_AHEAD_IDM_PRICE_15M_PREDICTION_GENERATED_ERROR',
  DAY_AHEAD_IDM_PRICE_60M_PREDICTION_GENERATED_SUCCESS = 'DAY_AHEAD_IDM_PRICE_60M_PREDICTION_GENERATED_SUCCESS',
  DAY_AHEAD_IDM_PRICE_60M_PREDICTION_GENERATED_WARNING = 'DAY_AHEAD_IDM_PRICE_60M_PREDICTION_GENERATED_WARNING',
  DAY_AHEAD_IDM_PRICE_60M_PREDICTION_GENERATED_ERROR = 'DAY_AHEAD_IDM_PRICE_60M_PREDICTION_GENERATED_ERROR',
  INTRA_DAY_IDM_PRICE_15M_PREDICTION_UPDATED_SUCCESS = 'INTRA_DAY_IDM_PRICE_15M_PREDICTION_UPDATED_SUCCESS',
  INTRA_DAY_IDM_PRICE_15M_PREDICTION_UPDATED_WARNING = 'INTRA_DAY_IDM_PRICE_15M_PREDICTION_UPDATED_WARNING',
  INTRA_DAY_IDM_PRICE_15M_PREDICTION_UPDATED_ERROR = 'INTRA_DAY_IDM_PRICE_15M_PREDICTION_UPDATED_ERROR',
  INTRA_DAY_IDM_PRICE_60M_PREDICTION_UPDATED_SUCCESS = 'INTRA_DAY_IDM_PRICE_60M_PREDICTION_UPDATED_SUCCESS',
  INTRA_DAY_IDM_PRICE_60M_PREDICTION_UPDATED_WARNING = 'INTRA_DAY_IDM_PRICE_60M_PREDICTION_UPDATED_WARNING',
  INTRA_DAY_IDM_PRICE_60M_PREDICTION_UPDATED_ERROR = 'INTRA_DAY_IDM_PRICE_60M_PREDICTION_UPDATED_ERROR',
  DAY_AHEAD_SYSTEM_IMBALANCE_PRICE_PREDICTION_GENERATED_SUCCESS = 'DAY_AHEAD_SYSTEM_IMBALANCE_PRICE_PREDICTION_GENERATED_SUCCESS',
  DAY_AHEAD_SYSTEM_IMBALANCE_PRICE_PREDICTION_GENERATED_WARNING = 'DAY_AHEAD_SYSTEM_IMBALANCE_PRICE_PREDICTION_GENERATED_WARNING',
  DAY_AHEAD_SYSTEM_IMBALANCE_PRICE_PREDICTION_GENERATED_ERROR = 'DAY_AHEAD_SYSTEM_IMBALANCE_PRICE_PREDICTION_GENERATED_ERROR',
  INTRA_DAY_SYSTEM_IMBALANCE_PRICE_PREDICTION_UPDATED_SUCCESS = 'INTRA_DAY_SYSTEM_IMBALANCE_PRICE_PREDICTION_UPDATED_SUCCESS',
  INTRA_DAY_SYSTEM_IMBALANCE_PRICE_PREDICTION_UPDATED_WARNING = 'INTRA_DAY_SYSTEM_IMBALANCE_PRICE_PREDICTION_UPDATED_WARNING',
  INTRA_DAY_SYSTEM_IMBALANCE_PRICE_PREDICTION_UPDATED_ERROR = 'INTRA_DAY_SYSTEM_IMBALANCE_PRICE_PREDICTION_UPDATED_ERROR',
  DAY_AHEAD_DEVICE_PRODUCTION_PLAN_PREDICTION_GENERATED_SUCCESS = 'DAY_AHEAD_DEVICE_PRODUCTION_PLAN_PREDICTION_GENERATED_SUCCESS',
  DAY_AHEAD_DEVICE_PRODUCTION_PLAN_PREDICTION_GENERATED_WARNING = 'DAY_AHEAD_DEVICE_PRODUCTION_PLAN_PREDICTION_GENERATED_WARNING',
  DAY_AHEAD_DEVICE_PRODUCTION_PLAN_PREDICTION_GENERATED_ERROR = 'DAY_AHEAD_DEVICE_PRODUCTION_PLAN_PREDICTION_GENERATED_ERROR',
  INTRA_DAY_DEVICE_PRODUCTION_PLAN_PREDICTION_UPDATED_SUCCESS = 'INTRA_DAY_DEVICE_PRODUCTION_PLAN_PREDICTION_UPDATED_SUCCESS',
  INTRA_DAY_DEVICE_PRODUCTION_PLAN_PREDICTION_UPDATED_WARNING = 'INTRA_DAY_DEVICE_PRODUCTION_PLAN_PREDICTION_UPDATED_WARNING',
  INTRA_DAY_DEVICE_PRODUCTION_PLAN_PREDICTION_UPDATED_ERROR = 'INTRA_DAY_DEVICE_PRODUCTION_PLAN_PREDICTION_UPDATED_ERROR',
  DAY_AHEAD_DELIVERY_POINT_PRODUCTION_PLAN_PREDICTION_GENERATED_SUCCESS = 'DAY_AHEAD_DELIVERY_POINT_PRODUCTION_PLAN_PREDICTION_GENERATED_SUCCESS',
  DAY_AHEAD_DELIVERY_POINT_PRODUCTION_PLAN_PREDICTION_GENERATED_WARNING = 'DAY_AHEAD_DELIVERY_POINT_PRODUCTION_PLAN_PREDICTION_GENERATED_WARNING',
  DAY_AHEAD_DELIVERY_POINT_PRODUCTION_PLAN_PREDICTION_GENERATED_ERROR = 'DAY_AHEAD_DELIVERY_POINT_PRODUCTION_PLAN_PREDICTION_GENERATED_ERROR',
  INTRA_DAY_DELIVERY_POINT_PRODUCTION_PLAN_PREDICTION_GENERATED_SUCCESS = 'INTRA_DAY_DELIVERY_POINT_PRODUCTION_PLAN_PREDICTION_GENERATED_SUCCESS',
  INTRA_DAY_DELIVERY_POINT_PRODUCTION_PLAN_PREDICTION_GENERATED_WARNING = 'INTRA_DAY_DELIVERY_POINT_PRODUCTION_PLAN_PREDICTION_GENERATED_WARNING',
  INTRA_DAY_DELIVERY_POINT_PRODUCTION_PLAN_PREDICTION_GENERATED_ERROR = 'INTRA_DAY_DELIVERY_POINT_PRODUCTION_PLAN_PREDICTION_GENERATED_ERROR',
  DAY_AHEAD_BALANCING_GROUP_IMBALANCE_PLAN_GENERATED_SUCCESS = 'DAY_AHEAD_BALANCING_GROUP_IMBALANCE_PLAN_GENERATED_SUCCESS',
  DAY_AHEAD_BALANCING_GROUP_IMBALANCE_PLAN_GENERATED_WARNING = 'DAY_AHEAD_BALANCING_GROUP_IMBALANCE_PLAN_GENERATED_WARNING',
  DAY_AHEAD_BALANCING_GROUP_IMBALANCE_PLAN_GENERATED_ERROR = 'DAY_AHEAD_BALANCING_GROUP_IMBALANCE_PLAN_GENERATED_ERROR',
  INTRA_DAY_BALANCING_GROUP_IMBALANCE_PLAN_UPDATED_SUCCESS = 'INTRA_DAY_BALANCING_GROUP_IMBALANCE_PLAN_UPDATED_SUCCESS',
  INTRA_DAY_BALANCING_GROUP_IMBALANCE_PLAN_UPDATED_WARNING = 'INTRA_DAY_BALANCING_GROUP_IMBALANCE_PLAN_UPDATED_WARNING',
  INTRA_DAY_BALANCING_GROUP_IMBALANCE_PLAN_UPDATED_ERROR = 'INTRA_DAY_BALANCING_GROUP_IMBALANCE_PLAN_UPDATED_ERROR',
  DAY_AHEAD_BALANCING_GROUP_DIAGRAM_PREDICTION_GENERATED_SUCCESS = 'DAY_AHEAD_BALANCING_GROUP_DIAGRAM_PREDICTION_GENERATED_SUCCESS',
  DAY_AHEAD_BALANCING_GROUP_DIAGRAM_PREDICTION_GENERATED_WARNING = 'DAY_AHEAD_BALANCING_GROUP_DIAGRAM_PREDICTION_GENERATED_WARNING',
  DAY_AHEAD_BALANCING_GROUP_DIAGRAM_PREDICTION_GENERATED_ERROR = 'DAY_AHEAD_BALANCING_GROUP_DIAGRAM_PREDICTION_GENERATED_ERROR',
  INTRA_DAY_BALANCING_GROUP_DIAGRAM_PREDICTION_UPDATED_SUCCESS = 'INTRA_DAY_BALANCING_GROUP_DIAGRAM_PREDICTION_UPDATED_SUCCESS',
  INTRA_DAY_BALANCING_GROUP_DIAGRAM_PREDICTION_UPDATED_WARNING = 'INTRA_DAY_BALANCING_GROUP_DIAGRAM_PREDICTION_UPDATED_WARNING',
  INTRA_DAY_BALANCING_GROUP_DIAGRAM_PREDICTION_UPDATED_ERROR = 'INTRA_DAY_BALANCING_GROUP_DIAGRAM_PREDICTION_UPDATED_ERROR',
  ENTSOE_IMBALANCE_DATA_LOADED = 'ENTSOE_IMBALANCE_DATA_LOADED',
  ENTSOE_DAY_AHEAD_GENERATION_DATA_LOADED = 'ENTSOE_DAY_AHEAD_GENERATION_DATA_LOADED',
  ENTSOE_DAY_AHEAD_LOAD_DATA_LOADED = 'ENTSOE_DAY_AHEAD_LOAD_DATA_LOADED',
  ENTSOE_ACTUAL_LOAD_DATA_LOADED = 'ENTSOE_ACTUAL_LOAD_DATA_LOADED',
  ENTSOE_DAY_AHEAD_PRICES_DATA_LOADED = 'ENTSOE_DAY_AHEAD_PRICES_DATA_LOADED',
  ENTSOE_DAY_AHEAD_WIND_SOLAR_GENERATION_DATA_LOADED = 'ENTSOE_DAY_AHEAD_WIND_SOLAR_GENERATION_DATA_LOADED',
  OKTE_IMBALANCE_DATA_LOADED = 'OKTE_IMBALANCE_DATA_LOADED',
  OKTE_SHORTTERM_MARKET_DATA_LOADED = 'OKTE_SHORTTERM_MARKET_DATA_LOADED',
  OKTE_INTRADAY_MARKET60MIN_DATA_LOADED = 'OKTE_INTRADAY_MARKET60MIN_DATA_LOADED',
  OKTE_INTRADAY_MARKET15MIN_DATA_LOADED = 'OKTE_INTRADAY_MARKET15MIN_DATA_LOADED',
  SOLCAST_WEATHER_FORECAST_LOADED = 'SOLCAST_WEATHER_FORECAST_LOADED',
  SOLCAST_WEATHER_HISTORIC_LOADED = 'SOLCAST_WEATHER_HISTORIC_LOADED',
  SOLCAST_DEVICE_WEATHER_FORECAST_LOADED = 'SOLCAST_DEVICE_WEATHER_FORECAST_LOADED',
  SOLCAST_DEVICE_WEATHER_HISTORIC_LOADED = 'SOLCAST_DEVICE_WEATHER_HISTORIC_LOADED',
  DEVICE_OPERATION_EVENT_OCCURRED = 'DEVICE_OPERATION_EVENT_OCCURRED',
  DEVICE_OPERATION_EVENT_RESOLVED = 'DEVICE_OPERATION_EVENT_RESOLVED',
  DELIVERY_POINT_OPERATION_EVENT_OCCURRED = 'DELIVERY_POINT_OPERATION_EVENT_OCCURRED',
  DELIVERY_POINT_OPERATION_EVENT_RESOLVED = 'DELIVERY_POINT_OPERATION_EVENT_RESOLVED',
  PREDICTION_TASK_FAILED = 'PREDICTION_TASK_FAILED',
  RESERVED_CAPACITY_GUARD_MODE_CHANGED = 'RESERVED_CAPACITY_GUARD_MODE_CHANGED',
  RESERVED_CAPACITY_GUARDING_CHECK_REQUESTED = 'RESERVED_CAPACITY_GUARDING_CHECK_REQUESTED',
  RESERVED_CAPACITY_GUARDING_CHECK_SUCCEEDED = 'RESERVED_CAPACITY_GUARDING_CHECK_SUCCEEDED',
  RESERVED_CAPACITY_GUARDING_CHECK_FAILED = 'RESERVED_CAPACITY_GUARDING_CHECK_FAILED',
  RESERVED_CAPACITY_GUARDING_ACTION_ACCEPTED = 'RESERVED_CAPACITY_GUARDING_ACTION_ACCEPTED',
  RESERVED_CAPACITY_GUARDING_ACTION_REJECTED = 'RESERVED_CAPACITY_GUARDING_ACTION_REJECTED',
  RESERVED_CAPACITY_UTILIZATION_WARNING = 'RESERVED_CAPACITY_UTILIZATION_WARNING',
  RESERVED_CAPACITY_EXCEEDED = 'RESERVED_CAPACITY_EXCEEDED',
  RESERVED_CAPACITY_EXCEEDED_NO_ACTIONS_POSSIBLE = 'RESERVED_CAPACITY_EXCEEDED_NO_ACTIONS_POSSIBLE',
  RESERVED_CAPACITY_GUARDING_ACTIONS_ISSUED = 'RESERVED_CAPACITY_GUARDING_ACTIONS_ISSUED',
  RESERVED_CAPACITY_GUARDING_ACTIONS_ACCEPTED = 'RESERVED_CAPACITY_GUARDING_ACTIONS_ACCEPTED'
}

export enum DailyDiagramValidationReason {
  MISSING_PRODUCTION_PLAN_REVISION = 'MISSING_PRODUCTION_PLAN_REVISION',
  PRODUCTION_PLAN_REVISION_OUT_OF_DAILY_DIAGRAM = 'PRODUCTION_PLAN_REVISION_OUT_OF_DAILY_DIAGRAM',
  PRODUCTION_PLAN_REVISION_IN_DRAFT_STATE = 'PRODUCTION_PLAN_REVISION_IN_DRAFT_STATE',
  NEWER_REVISION_FOR_DRAFT_PRODUCTION_PLAN_REVISION_EXISTS = 'NEWER_REVISION_FOR_DRAFT_PRODUCTION_PLAN_REVISION_EXISTS'
}

export enum DispatcherValidationError {
  MUST_BE_INTEGER = 'MUST_BE_INTEGER',
  MAX_2_DECIMALS = 'MAX_2_DECIMALS',
  MAX_3_DECIMALS = 'MAX_3_DECIMALS',
  MAX_5_DECIMALS = 'MAX_5_DECIMALS',
  MAX_6_DECIMALS = 'MAX_6_DECIMALS',
  MIN_VALUE = 'MIN_VALUE',
  MAX_VALUE = 'MAX_VALUE',
  MUST_BE_ONE_OF = 'MUST_BE_ONE_OF',
  NOT_A_NUMBER = 'NOT_A_NUMBER',
  EXPONENTIAL_NUMBER = 'EXPONENTIAL_NUMBER',
  POSITIVE_NUMBER = 'POSITIVE_NUMBER'
}

export interface ProductionPlanningDevice extends DeviceInterface {
  currentRevision?: ProductionPlanRevisionInterface;
  prediction?: DataPointInterface[];
}

export interface ProductionPlanningDeliveryPoint {
  deliveryPointId: string;
  deliveryPointName: string;
  deviceList: ProductionPlanningDevice[];
}

export interface PlanTableBodyRowError {
  periodTimeUnitNumber: number;
  message: string | undefined;
}

export interface ProductionChangeEvent {
  event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>;
  deliveryPointId: string;
  deviceId: string | bigint;
  periodTimeUnitNumber: number;
  errorMessage?: string | undefined;
}

export interface UpsertProductionPlanDeliveryPointsParams {
  productionPlanDeliveryPoints: ProductionPlanningDeliveryPoint[];
  marketPeriods: MarketPeriodInterface[];
  deliveryPointId: string;
  deviceId: string | bigint;
  periodTimeUnitNumber: number;
  valueForPeriod: number | string;
  errorMessageForPeriod?: string;
}

export interface CalendarRevision {
  date: string;
  day: string;
}

export type StepIconProps = {
  completed: boolean;
  active: boolean;
  error: boolean;
  icon: number;
  theme: Theme;
  selectedBusinessDay?: string;
};

export interface GetTimeSeriesRequestBodyProps {
  interval: TimeIntervalInterface;
  metricType: MetricValueType;
  monitoredResourceType: MonitoredResourceType;
  monitoredResourceLabelKey?: MonitoredResourceTypeLabel;
  monitoredResourceLabelValue?: string | bigint;
  transformationFilter?: { unitOfMeasure: UnitType };
}

export type ValidationProdInputProps = {
  value: string;
  productionPlanUnits: UnitType;
  productionPlanPeriodDuration: MarketPeriodsType;
  min?: number | undefined;
  max?: number | undefined;
  oneOf?: number[];
};

export type CsvExport = {
  columns: Columns;
  datas: Datas;
  filename: string;
};

export type GetNominationCsvExportProps = {
  dailyDiagram: DailyDiagramInterface | undefined;
  productionPlanList: GetDeviceProductionPlanDetailResponse[];
  marketPeriods: MarketPeriodInterface[];
};
